var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48508 2.49488C9.15808 1.32788 10.8421 1.32788 11.5151 2.49488L17.7951 13.3699C18.4681 14.5369 17.6251 15.9949 16.2791 15.9949H3.72008C2.37308 15.9949 1.53108 14.5369 2.20508 13.3699L8.48508 2.49488ZM10.0001 4.99988C10.199 4.99988 10.3898 5.0789 10.5304 5.21955C10.6711 5.3602 10.7501 5.55097 10.7501 5.74988V9.24988C10.7501 9.44879 10.6711 9.63956 10.5304 9.78021C10.3898 9.92086 10.199 9.99988 10.0001 9.99988C9.80117 9.99988 9.6104 9.92086 9.46975 9.78021C9.32909 9.63956 9.25008 9.44879 9.25008 9.24988V5.74988C9.25008 5.55097 9.32909 5.3602 9.46975 5.21955C9.6104 5.0789 9.80117 4.99988 10.0001 4.99988ZM10.0001 13.9999C10.2653 13.9999 10.5196 13.8945 10.7072 13.707C10.8947 13.5194 11.0001 13.2651 11.0001 12.9999C11.0001 12.7347 10.8947 12.4803 10.7072 12.2928C10.5196 12.1052 10.2653 11.9999 10.0001 11.9999C9.73486 11.9999 9.48051 12.1052 9.29297 12.2928C9.10543 12.4803 9.00008 12.7347 9.00008 12.9999C9.00008 13.2651 9.10543 13.5194 9.29297 13.707C9.48051 13.8945 9.73486 13.9999 10.0001 13.9999Z",
    fill: "#54ff99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.78859d9a61a775650311db546ac0d3e8.svg";
export { ForwardRef as ReactComponent };